import { ServiceGroup, ServiceItem } from 'orderme-api-integration-client';
import { ITracker } from './tracker';

class TrackersRunner {
  private static _instance: TrackersRunner;
  private trackers: ITracker[] = [];

  private constructor() {}

  static instance(): TrackersRunner {
    return this._instance ?? (this._instance = new TrackersRunner());
  }

  register(tracker: ITracker): void {
    if (!tracker) {
      return;
    }
    if (this.trackers.includes(tracker)) {
      return;
    }
    this.trackers.push(tracker);
  }

  unregister(tracker: ITracker): void {
    const i = this.trackers.indexOf(tracker);
    if (i >= 0) {
      this.trackers.splice(i, 1);
    }
  }

  clear(): void {
    this.trackers.length = 0;
  }

  identifyContact(): void {
    this.active().forEach((t) => {
      try {
        t.identifyContact();
      } catch {
        /* ignore */
      }
    });
  }

  trackPage(): void {
    this.active().forEach((t) => {
      try {
        t.trackPage();
      } catch {
        /* ignore */
      }
    });
  }

  viewedProductsGroup(serviceGroup: ServiceGroup, productUrl: string): void {
    this.active().forEach((t) => {
      try {
        t.viewedProductsGroup(serviceGroup, productUrl);
      } catch {
        /* ignore */
      }
    });
  }

  viewedProduct(serviceItem: ServiceItem, productUrl: string): void {
    this.active().forEach((t) => {
      try {
        t.viewedProduct(serviceItem, productUrl);
      } catch {
        /* ignore */
      }
    });
  }

  startedCheckout(): void {
    this.active().forEach((t) => {
      try {
        t.startedCheckout();
      } catch {
        /* ignore */
      }
    });
  }

  private active(): ITracker[] {
    return this.trackers.filter((t) => {
      try {
        return t.canTrack();
      } catch {
        return false;
      }
    });
  }
}

export const trackersRunner = TrackersRunner.instance();
